import { render, staticRenderFns } from "./sdkItem.vue?vue&type=template&id=e9653192&scoped=true&"
import script from "./sdkItem.vue?vue&type=script&lang=js&"
export * from "./sdkItem.vue?vue&type=script&lang=js&"
import style0 from "./sdkItem.vue?vue&type=style&index=0&id=e9653192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9653192",
  null
  
)

export default component.exports